import { createContext } from "react";
export const ModalStackContext = createContext(null);
